import Base from "../Step.es6";

// Edit users image
export default class extends Base {
    constructor(Configurator) {
        super('create', Configurator.mode.DESIGN_USER, Configurator);
        this.values = {
            id: null,
        };
    }

    required() {
        return ['upload', 'edit', 'color'];
    }
    validate() {
        return (this.values.id);
    }
    commit(values) {
        this.values.id = values.id;
        const selector = this.Configurator.Progress.get('selector');
        selector.save(values.id);
        selector.ready = true;
        for (const step of this.required()) this.Configurator.Progress.get(step).remove();
        // We have designs hash, we go back to hash mode
        this.Configurator.mode = Configurator.mode.DESIGN_HASH;
        this.ready = true;
        this.Configurator.Progress.get('text').ready = false;
        this.Configurator.update();
        return this;
    }
    remove() {
        this.values.id = null;
        this.Configurator.Progress.get('selector').remove();
        return this;
    }
    run() {
        this.Configurator.saveOrUpdate();
        return this;
    }
}
